(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4923],{

/***/ 55973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/open-bank-account/index.js + 1 modules
var open_bank_account = __webpack_require__(53001);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/saint-kitts-and-nevis/open-bank-account/data.json
var data_namespaceObject = JSON.parse('{"country":"St. Kitts & Nevis","imgAlt":"open bank account for Nevis company","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"St. Kitts & Nevis","uri":"/company-formation/saint-kitts-and-nevis"},{"title":"Open bank account","uri":"/company-formation/saint-kitts-and-nevis/open-bank-account"}],"dataPageType":[{"title":"Company Formation","uri":"/company-formation/saint-kitts-and-nevis"},{"title":"Open Bank Account","uri":"/company-formation/saint-kitts-and-nevis/open-bank-account"},{"title":"Other Services","uri":"/company-formation/saint-kitts-and-nevis/other-services"}],"dataHowToOpen":{"title":"How to open a bank account for <br/>St. Kitts & Nevis company","content":["<p>One initial step to start your offshore business venture is to apply for a ​business bank account. This allows business owners to keep their business depositing and expenditure separate from personal accounts, meaning better limited liability protection and enhanced credibility for your business. As for  St.Kitts & Nevis company, there are common application choices to open your business account:</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Applying in a local bank in St. Kitts & Nevis:</h3>","<p>Located in the Leeward Islands region of the Eastern Caribbean, the Federation of St. Kitts and Nevis achieved its independence in 1983. Today, the country is a member of Eastern Caribbean Currency Union (ECCU) comprised of 8 territories including Saint Kitts and Nevis. The central bank of ECCU is Eastern Caribbean Central Bank (ECCB) responsible for regulating the banking industry of the group in collaboration with each participating member. St. Kitts and Nevis has its own supervision framework for anti-money laundering, and is a member of the Caribbean Financial Action Task Force (CFATF).</p>","<p>All banks and financial institutions operating in St. Kitts and Nevis are required to be licensed by the ECCB. Financial sector of the country is small and well dominated by banks comprised of 2 local banks i.e. Bank of Nevis Ltd, St Kitts-Nevis-Anguilla National Bank Ltd, 4 branches and subsidiaries of foreign banks, namely Bank of Nova Scotia, CIBC FirstCaribbean International Bank (Barbados) Ltd, Royal Bank of Canada and RBTT Bank (SKN) Ltd.</p>","<p>Like other offshore banks, one of the main advantages of opening a BVI bank account for businesses is that no personal visit is required.</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Going for offshore bank accounts or fintech solutions</h3>","<p>A foreign company incorporated in St. Kitts and Nevis is not required to open a bank account there. In addition, there is no direct legislation controlling transferring funds into and outside of the country. Foreign companies can freely repatriate dividends and profits to the extent of its foreign business.</p>"]},"dataRequiredDocument":{"note":"","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"The below list show some general documents that might be required to open your bank account:","listContent":[{"text":"Account opening form;","content":[]},{"text":"Bank statements of latest 6 months;","content":[]},{"text":"Bank reference letter dated less than 3 months;","content":[]},{"text":"Certified copies of valid passports and residency proofs within 3 months for all directors/ shareholders/ account signatories;","content":[]},{"text":"Business trading proofs;","content":[]},{"text":"Copies of corporate documents.","content":[]}]}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/saint-kitts-and-nevis/open-bank-account/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(open_bank_account/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country/* saint_kitts_and_nevis */.OU,
        emi: bank_emis/* saint_kitts_and_nevis */.OU
      }
    })
  });
}

/***/ }),

/***/ 84898:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/saint-kitts-and-nevis/open-bank-account",
      function () {
        return __webpack_require__(55973);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,2864,58,5881,5999,6618,2888,179], function() { return __webpack_exec__(84898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);